import type {
  CSSProperties,
  KeyboardEvent,
  PointerEvent as ReactPointerEvent,
  ReactNode,
  RefObject,
} from 'react';
import type { DataElScope } from '@/utils/dataEl';
import type { FontWeight } from '@/theme/typography';

export const TABLE_TEXT_ALIGN = {
  Left: 'left',
  Center: 'center',
  Right: 'right',
} as const;

export type CmarkdowntableTextAlign = typeof TABLE_TEXT_ALIGN[keyof typeof TABLE_TEXT_ALIGN];

export interface CmarkdowntableCell {
  content: ReactNode;
  align?: CmarkdowntableTextAlign | null;
  /** Hebrew-led cell: render right-to-left at a lighter weight. */
  hebrew?: boolean;
}

export interface CmarkdowntableProps {
  dataElScope: DataElScope;
  headerCells: CmarkdowntableCell[];
  rows: CmarkdowntableCell[][];
  className?: string;
  style?: CSSProperties;
  textSize?: number;
  textWeight?: FontWeight;
  textAlign?: CmarkdowntableTextAlign;
  defaultExpanded?: boolean;
}

export interface CmarkdowntableBodyProps extends CmarkdowntableProps {
  tableElementRef: RefObject<HTMLDivElement | null>;
}

export interface CmarkdowntablePopoverEntry {
  title: string;
  value: string;
}

export interface CmarkdowntablePopoverPosition {
  left: number;
  top: number;
  width: number;
}

export interface CmarkdowntablePopoverRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export interface PopoverDragState {
  pointerId: number;
  startPointerX: number;
  startPointerY: number;
  startLeft: number;
  startTop: number;
  width: number;
  height: number;
}

export interface PopoverResizeState {
  pointerId: number;
  startPointerX: number;
  startPointerY: number;
  startWidth: number;
  startHeight: number;
  left: number;
  top: number;
}

export interface OpenTablePopoverRowInput {
  rowIndex: number;
  row: CmarkdowntableCell[];
  anchorElement: HTMLDivElement;
}

export interface TableRowKeyDownInput {
  event: KeyboardEvent<HTMLDivElement>;
  rowIndex: number;
  row: CmarkdowntableCell[];
  anchorElement: HTMLDivElement;
}

export type TablePopoverPointerHandler = (event: ReactPointerEvent<HTMLDivElement>) => void;
